const LOAD_SEARCHABLE_ROUTES = (state, payload) => {
    state.searchableRoutes = payload;
};

export default {
    LOAD_SEARCHABLE_ROUTES,
};
